import React from 'react'
import compose from 'recompose/compose'
import { withI18n } from '../../hocs'
import PropTypes from 'prop-types'
import { FunnelStatisticLegacyStyled, FunnelItem, FunnelInfo } from './styled'
import Grid from '@material-ui/core/Grid'
import Divider from '@material-ui/core/Divider'
import i18n from '../../../assets/i18n'
import { isArray, isNumber } from "lodash";

const FunnelStatisticLegacy = ({ title, funnel, extraData }) => {
  const opacity = ["33", "66", "AA", "CC", "FF"]

  // Normalizamos el funnel para evitar casos legacy raros
  const normalized = (funnel || []).map((node) => {
    if (!node || isArray(node) || typeof node !== 'object') {
      return { employees: 0, total: 0, leavers: 0 }
    }

    return {
      ...node,
      employees: Number(node.employees || 0),
      total: Number(node.total || 0),
      leavers: Number(node.leavers || 0),
    }
  })

  // Numerador acumulado desde la fase actual hasta la última
  const cumulativeNumerators = normalized.map((_, i) =>
    normalized.slice(i).reduce((acc, n) => acc + (n.employees || 0), 0)
  )

  // Denominador raw de cada fase (sin acumular entre fases)
  const phaseDenominators = normalized.map((n) => n.total || 0)

  // % por fase respecto a su propio denominador raw
  const phasePercents = cumulativeNumerators.map((num, i) =>
    phaseDenominators[i] > 0 ? (num / phaseDenominators[i]) * 100 : 0
  )

  return (
    <FunnelStatisticLegacyStyled>
      <Grid container spacing={0} className="card-container">
        <Grid item xs={12} className="label-stat funnel-title">
          <span>{title}</span>
          {isNumber(extraData) && (
            <span className="extra-data">
              {i18n.onboardingStatisticsItems.leaving} {extraData}
            </span>
          )}
        </Grid>
        <Grid item xs={12} className="label-stat">
          {normalized &&
            normalized.map((node, item) => {
              const nodeEmployees = cumulativeNumerators[item]
              const nodeTotal = phaseDenominators[item]

              // % de ESTA fase (ancho inferior)
              const bottomPercent = Number(phasePercents[item].toFixed(1))

              // % de la fase ANTERIOR (ancho superior). En la primera fase, 100%.
              const topPercent =
                item === 0 ? 100 : Number(phasePercents[item - 1].toFixed(1))

              // Seguridad para que nunca se ensanche por datos inconsistentes
              const safeTop = Math.max(topPercent, bottomPercent)

              return (
                <Grid key={item} container spacing={0}>
                  <Divider className="full" />

                  <Grid item xs={8} md={6} className="value-stat">
                    <FunnelItem top={safeTop} bottom={bottomPercent} opacity={opacity[item]}>
                      {nodeEmployees}/{nodeTotal}
                    </FunnelItem>
                  </Grid>

                  <Grid item xs={4} md={6} className="container-info">
                    <FunnelInfo>
                      <div className="title">
                        {i18n.onboardingStatisticsItems.phase} {item + 1}
                      </div>

                      {node && Object.prototype.hasOwnProperty.call(node, 'leavers') && (
                        <div className="title">
                          {i18n.onboardingStatisticsItems.leaving} {node.leavers || 0}
                        </div>
                      )}

                      <div className="value">{bottomPercent} %</div>
                    </FunnelInfo>
                  </Grid>
                </Grid>
              )
            })}

          <Divider className="full" />
        </Grid>

      </Grid>
    </FunnelStatisticLegacyStyled>
  )
}

FunnelStatisticLegacy.propTypes = {
  title: PropTypes.string,
  funnel: PropTypes.array,
}

FunnelStatisticLegacy.defaultProps = {
  title: "Funnel", funnel: []
}

const enharce = compose(withI18n)

export default enharce(FunnelStatisticLegacy)
